import { render, staticRenderFns } from "./login_way.vue?vue&type=template&id=3d22c174&scoped=true&"
import script from "./login_way.vue?vue&type=script&lang=js&"
export * from "./login_way.vue?vue&type=script&lang=js&"
import style0 from "./login_way.vue?vue&type=style&index=0&id=3d22c174&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d22c174",
  null
  
)

export default component.exports